// @ts-nocheck
import React, { useState, useEffect } from "react";
import { AverageCommentsGraph } from ".";
import {
  useGetAverageCommentsByAccountIdQuery,
  LineChartFilter,
  DataSourcePlatform,
} from "src/generated/ApolloComponents";

interface Props {
  accountId?: string;
  username: string;
  platformType: string;
  onChangeData?: (data) => void;
}

export const AverageCommentsGraphContainer: React.FC<Props> = ({
  accountId,
  username,
  platformType,
  onChangeData,
}) => {
  const [period, setPeriod] = useState("HalfYear");

  let queryData = {
    username: username,
    filter: period as LineChartFilter,
    platformType: platformType as DataSourcePlatform,
  } as any;

  if (accountId) {
    queryData["accountId"] = accountId;
  }

  const { data, loading, error } = useGetAverageCommentsByAccountIdQuery({
    variables: queryData,
  });

  const graphData = data?.getAverageCommentsByAccountId || [];

  useEffect(() => {
    if (onChangeData) onChangeData(graphData);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [graphData]);

  //get last not null value from array
  let lastItem = graphData.filter(x => x?.value != null).slice(-1)[0];

  if (!loading && (error || graphData?.length === 0)) return null;

  return (
    <AverageCommentsGraph
      loading={loading}
      data={graphData}
      period={period}
      setPeriod={value => setPeriod(value)}
      titleValue={lastItem?.value}
    />
  );
};
